import { ID_LEITE_VACA } from "@/utils/types.js";
import strings from "../../../lang/Strings";

export default {
  dark: false,
  cupons: [],
  notificacoes: [],
  consultoria: {
    clienteSelecionado: null,
    clientes: [],
    info: {},
  },
  tipos: [],
  tabHome: -1,
  loading: false,
  msgState: null,
  dietaRefinada: {
    tipo: "MN",
    dieta: {},
  },
  dietasAtivas: null,
  dietasCompartilhadasComOutros: null,
  dietasCompartilhadasComigo: null,
  predicoesCompartilhadasComOutros: null,
  predicoesCompartilhadasComigo: null,
  data: null,
  map: null,
  coords: [],
  dieta_salva: null,
  acesso_premium: false,
  vinculados: null,
  alimentos_empresa: null,
  alimentos_usuario: null,
  step: null,
  menu1: false,
  menu2: false,
  menu4: false,
  menu3: false,
  curr_version: "2.0.0",
  tipo: "FD",
  animal_: null,
  color: process.env.VUE_APP_COLOR ? process.env.VUE_APP_COLOR : "success",
  drawer: null,
  responsive: false,
  idioma: 0,
  image: "./img/background-drawer.jpg",
  isIOS: !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent),
  exibeRelatoriosGoogle: process.env.VUE_APP_MOSTRA_RELATORIOS_GOOGLE
    ? parseInt(process.env.VUE_APP_MOSTRA_RELATORIOS_GOOGLE) === 1
    : true,
  exibeTesteGratis: process.env.VUE_APP_MOSTRA_TESTE_GRATIS
    ? parseInt(process.env.VUE_APP_MOSTRA_TESTE_GRATIS) === 1
    : true,
  descricaoLogoPrincipal: process.env.VUE_APP_DESCRICAO_LOGO_CNPJ
    ? process.env.VUE_APP_DESCRICAO_LOGO_CNPJ
    : "Br Corte Soluções Em Pecuaria Ltda. \nCNPJ: 41.091.007/0001-43",
  redirecionaNaoLogado: process.env.VUE_APP_REDIRECIONA_INICIAL
    ? parseInt(process.env.VUE_APP_REDIRECIONA_INICIAL) === 1
    : true,
  exibeLoja: process.env.VUE_APP_EXIBE_LOJA
    ? parseInt(process.env.VUE_APP_EXIBE_DESCRICAO_BRCORTE) === 1
    : true,
  exibeConteudoApresentacao: process.env.VUE_APP_EXIBE_DESCRICAO_BRCORTE
    ? parseInt(process.env.VUE_APP_EXIBE_DESCRICAO_BRCORTE) === 1
    : true,
  exibeBlog: process.env.VUE_APP_EXIBE_BLOG
    ? parseInt(process.env.VUE_APP_EXIBE_BLOG) === 1
    : true,
  exibeFerramentas: process.env.VUE_APP_MOSTRA_FERRAMENTAS
    ? parseInt(process.env.VUE_APP_MOSTRA_FERRAMENTAS) === 1
    : false,
  permiteCadastro: process.env.VUE_APP_CADASTRO_GRATUITO
    ? parseInt(process.env.VUE_APP_CADASTRO_GRATUITO) === 1
    : true,
  exibeBotaoSignin: process.env.VUE_APP_EXIBE_BOTAO_SIGNIN
    ? parseInt(process.env.VUE_APP_EXIBE_BOTAO_SIGNIN) === 1
    : true,
  linkGooglePlay: process.env.VUE_APP_PLAY_STORE
    ? process.env.VUE_APP_PLAY_STORE
    : "https://play.google.com/store/apps/details?id=com.dinni.appBrCorte&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
  linkApple: process.env.VUE_APP_APP_STORE
    ? process.env.VUE_APP_APP_STORE
    : "https://apps.apple.com/br/app/brcorte/id1498493049",
  // sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)',
  /*
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.70)',
  sidebarBackgroundFooterColor: 'rgba(27, 27, 27, 0.74)',
  */
  sidebarBackgroundColor: process.env.VUE_APP_SIDEBAR_BG
    ? process.env.VUE_APP_SIDEBAR_BG
    : "rgba(27, 27, 27, 0.70)",
  sidebarBackgroundFooterColor: process.env.VUE_APP_SIDEBAR_BG
    ? process.env.VUE_APP_SIDEBAR_BG
    : "rgba(27, 27, 27, 0.74)",

  trava_back: false,
  alert: {
    ativo: false,
    msg: "",
    msg_type: "success",
    time: 6000,
  },
  token: null,
  user: null,
  empresa: null,
  acesso: null,
  exigencias: null,
  exigencias_selecionadas: null,
  animal: null,
  categorias_alimentos: null,
  alimentos_selecionados: [],
  dietas: [],
  predicoes: [],
  racoes: [],
  tabelas: [],
  composicao_dieta: null,
  composicao_racao: null,
  dados_predicao: null,
  excrecao: null,
  relatorio_financeiro: null,
  relatorio_financeiro_cenarios: [],
  restricoes: {
    searchRestricao: null,
    indexAlimentoDialog: 0,
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0,
    },
    dialogNutrientes: false,
  },

  vc: null,
  fixavc: false,
  exportando_dados: false,
  dieta_calculada: false,
  modal: {
    msg: "",
    title: "",
    optionsYN: {
      yes: {
        titulo: ["Sim", "Yes", "Si"],
        valor: "sim",
        classe: "success",
        closes: true,
      },
      no: {
        titulo: ["Não", "No", "No"],
        valor: "nao",
        classe: "error",
        closes: true,
      },
    },
    optionsOK: {
      ok: {
        titulo: ["OK", "OK", "OK"],
        valor: "ok",
        classe: "primary",
        closes: true,
      },
    },
    options: {},
    optionsType: "OK",
    returns: null,
    responseCallback: null,
    active: false,
  },
  reset_options: [
    {
      id: 1,
      title: ["Limpar Tela", "Screen Reset", "Borrar Pantalla"],
    },
    {
      id: 2,
      title: ["Limpar Dieta", "Diet Reset", "Borrar Dieta"],
    },
  ],
  save_options: [
    {
      id: 1,
      title: [
        "Relatório Completo (PDF)",
        "Full Report (PDF)",
        "Informe completo (PDF)",
      ],
      pertence: "E",
      value: "pdf",
    },
    {
      id: 1,
      title: [
        "Relatório Completo (PDF)",
        "Full Report (PDF)",
        "Informe completo (PDF)",
      ],
      pertence: "CR",
      value: "pdf",
    },
    {
      id: 2,
      title: [
        "Relatório de Campo (PDF)",
        "Field Report (PDF)",
        "Informe de campo (PDF)",
      ],
      pertence: "CR",
      value: "campo_pdf",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 0,
      title: ["Salvar Dieta", "Save Diet", "Guardar Dieta"],
      value: "salvar_dieta",
      pertence: "FD",
      escondeExigencias: true,
      pecuarista: true,
      premium: true,
    },
    {
      id: 6,
      title: [
        "Salvar Dieta para...",
        "Save Diet to...",
        "Guarda la dieta para...",
      ],
      value: "salvar_dieta_como",
      pertence: "FD",
      escondeExigencias: true,
      consultor: true,
    },
    {
      id: 1,
      title: [
        "Relatório Completo (PDF)",
        "Full Report (PDF)",
        "Informe completo (PDF)",
      ],
      pertence: "FD",
      value: "pdf",
    },
    {
      id: 2,
      title: [
        "Fórmula da Dieta (PDF)",
        "Diet Formula (PDF)",
        "Fórmula de la dieta (PDF)",
      ],
      pertence: "FD",
      value: "spdf",
      escondeExigencias: true,
    },
    {
      id: 4,
      title: [
        "Relatório de Campo (PDF)",
        "Field Report (PDF)",
        "Informe de campo (PDF)",
      ],
      pertence: "FD",
      value: "campo_pdf",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 5,
      title: [
        "Relatório de Mistura (PDF)",
        "Mix Report (PDF)",
        "Informe de mezcla (PDF)",
      ],
      pertence: "FD",
      value: "premix_pdf",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 7,
      title: [
        "Análise por IA",
        "AI-powered analysis",
        "Análisis impulsado por IA",
      ],
      pertence: "FD",
      value: "analise_ia",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 0,
      title: ["Salvar Predição", "Save Prediction", "Guardar predicción"],
      value: "salvar_dieta",
      pertence: "PD",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 1,
      title: [
        "Relatório Completo (PDF)",
        "Full Report (PDF)",
        "Informe completo (PDF)",
      ],
      pertence: "PD",
      value: "pdf",
    },
    {
      id: 2,
      title: [
        "Fórmula da Predição (PDF)",
        "Prediction Formula (PDF)",
        "Fórmula de predicción (PDF)",
      ],
      pertence: "PD",
      value: "spdf",
      escondeExigencias: true,
    },
    {
      id: 3,
      title: [
        "Relatório de Campo (PDF)",
        "Field Report (PDF)",
        "Informe de campo (PDF)",
      ],
      pertence: "PD",
      value: "campo_pdf",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 5,
      title: [
        "Relatório de Mistura (PDF)",
        "Mix Report (PDF)",
        "Informe de mezcla (PDF)",
      ],
      pertence: "PD",
      value: "premix_pdf",
      escondeExigencias: true,
      premium: true,
    },
    {
      id: 4,
      value: "cria_suplemento",
      pertence: "PD",
      title: [
        "Criar Suplemento",
        "Create Supply",
        "Crear Complemento Alimenticio",
      ],
      premium: true,
    },
    {
      id: 6,
      title: [
        "Salvar Predição Para...",
        "Save prediction to...",
        "Guardar predicción en...",
      ],
      value: "salvar_predicao_como",
      pertence: "PD",
      escondeExigencias: true,
      consultor: true,
      premium: true,
    },
    {
      id: 7,
      title: [
        "Análise por IA",
        "AI-powered analysis",
        "Análisis impulsado por IA",
      ],
      pertence: "PD",
      value: "analise_ia",
      escondeExigencias: true,
      premium: true,
    },
  ],
  unidades: [
    {
      id: "kg",
      title: ["kg", "kg", "kg"],
      fator: 1,
    },
    {
      id: "g",
      title: ["g", "g", "g"],
      fator: 0.001,
    },
    {
      id: "mg",
      title: ["mg", "mg", "mg"],
      fator: 0.000001,
    },
  ],
  links: null,
  links_: [
    {
      to: "/dashboard",
      icon: "mdi-poll-box",
      text: ["Início", "Home", "Página de Inicio"],
      textHome: [
        "Gráficos e Relatórios de Desempenho",
        "Performance Charts and Reports",
        "Gráficos e informes de rendimiento",
      ],
      access: 0,
    },
    {
      to: "/formulacao-dieta",
      icon: "mdi-silo",
      text: [
        "Formulação de Dietas",
        "Diet Formulation",
        "Formulación de Dieta",
      ],
      access: 0,
    },
    {
      to: "/predicao-desempenho",
      icon: "mdi-chart-line",
      text: [
        "Predição de Desempenho",
        "Performance Prediction",
        "Predicción de Desempeño",
      ],
      access: 0,
    },
    // {
    //   to: "/tabela-resumida",
    //   icon: "mdi-nutrition",
    //   text: [
    //     "Tabela Resumida",
    //     "Short Feed Composition Table",
    //     "Tabla de composición de alimentación corta",
    //   ],
    //   access: 0,
    // },
    {
      to: "/enviar-alimento",
      icon: "mdi-corn",
      text: ["Alimentos", "Feeds", "Alimentos"],
      textHome: [
        "Gerenciar Alimentos Próprios ou de Empresa",
        "Feeds",
        "Alimentos",
      ],
      access: 0,
      oculta: false,
    },
    {
      to: "/formulacao-suplemento",
      icon: "mdi-crop-landscape",
      text: [
        "Formular Suplemento",
        "Formulate Supplement",
        "Formular Suplemento",
      ],
      access: 0,
      oculta: true,
      naoAparecer: ["pecuarista"],
    },
    {
      to: "/calcula-exigencias",
      icon: "mdi-calculator",
      text: [
        "Calcular Exigências",
        "Get Requirements",
        "Calcular Requerimientos",
      ],
      access: 0,
    },
    {
      to: "/calcular-racao",
      icon: "mdi-nutrition",
      text: [
        "Composição da Mistura",
        "Mixture composition",
        "Composición de la mezcla",
      ],
      access: 0,
      naoAparecer: ["pecuarista"],
    },
    {
      to: "/ferramentas",
      icon: "mdi-toolbox",
      text: [
        "Ferramentas & Calculadoras",
        "Tools & Calc",
        "Herramientas & Calc"
      ],
      oculta: !(process.env.VUE_APP_MOSTRA_FERRAMENTAS ? parseInt(process.env.VUE_APP_MOSTRA_FERRAMENTAS) === 1 : false),
      access: 0
    },
    // {
    //   to: '/seja-premium',
    //   icon: 'mdi-star',
    //   text: ['Seja Premium', 'Be Premium'],
    //   textHome: ['Gerenciar Alimentos Próprios ou de Empresa', 'Feeds'],
    //   access: 0,
    //   oculta: true
    // },

    {
      to: "/studio/",
      icon: "mdi-domain",
      text: ["BR-Corte Studio", "BR-Corte Studio", "BR-Corte Studio"],
      textHome: ["Gestão empresarial, clientes e indicadores", "Company management, clients and analytics", "Gestión empresarial, clientes e indicadores"],
      access: 1,
    },
    {
      to: "/seja-premium",
      icon: "mdi-star",
      text: ["Nossos Planos", "Our Plans", "Nuestros planes"],
      textHome: [
        "Gerenciar Alimentos Próprios ou de Empresa",
        "Feeds",
        "Nuestros planes",
      ],
      access: 0,
    },
    {
      to: "/adm",
      icon: "mdi-settings",
      text: ["Administração", "Admin", "Administración"],
      textHome: ["Customize", "Custom", "Custom"],
      access: 10,
    },
  ],
  menus: {
    instrucoes: [
      {
        title: ["Instruções", "Instructions", "Instrucciones"],
        action: `${process.env.VUE_APP_BRCORTE_SITE}/videos`,
      },
      {
        title: ["Apresentação", "Presentation", "Presentación"],
        action: `${process.env.VUE_APP_BRCORTE_SITE}/pesquisa#sobre`,
      },
      {
        title: ["Como colaborar", "How to contribute", "Cómo colaborar"],
        action: "/colaborar",
      },
      {
        title: ["Autores e Citação", "Authors and citation", "Autores y cita"],
        action: "/autores",
      },
      {
        title: ["Termos de Uso", "Terms of Service", "Terminos de Uso"],
        action: `${process.env.VUE_APP_BRCORTE_SITE}/termos`,
      },
      {
        title: [
          "Política de Privacidade",
          "Privacy Policy",
          "Política de Privacidad",
        ],
        action: `${process.env.VUE_APP_BRCORTE_SITE}/politica-de-privacidade`,
      },
    ],
    livros: [
      {
        title: ["Blog", "Blog", "Blog"],
        action: `${process.env.VUE_APP_BRCORTE_SITE}/posts`,
        nova_aba: true,
      },
      {
        title: ["Curso Gravado", "Course", "Curso"],
        action: `/cursos`,
        nova_aba: true,
      },
      {
        title: ["APP IOS", "APP IOS", "APP IOS"],
        action: "https://apps.apple.com/br/app/brcorte/id1498493049",
        nova_aba: true,
      },
      {
        title: ["APP Android", "APP Android", "APP Android"],
        action:
          "https://play.google.com/store/apps/details?id=com.dinni.appBrCorte",
        nova_aba: true,
      },
      {
        title: ["Sistema CQBAL", "CQBAL Software 4.0", "CQBAL"],
        action: "https://www.cqbal.com.br/",
        nova_aba: true,
      },
      {
        title: [
          "BR-Corte 2010 (Português)",
          "BR-Corte 2010 (Portuguese)",
          "BR-Corte 2010 (Lengua portuguesa)",
        ],
        action: "/livrobr",
      },
      {
        title: [
          "BR-Corte 2010 (Inglês)",
          "BR-Corte 2010 (English)",
          "BR-Corte 2010 (Inglés)",
        ],
        action: "/livroen",
      },
      {
        title: [
          "BR-Corte 2016 (Português)",
          "BR-Corte 2016 (Portuguese)",
          "BR-Corte 2016 (Lengua portuguesa)",
        ],
        action: "/livro2016br",
      },
      {
        title: [
          "BR-Corte 2016 (Inglês)",
          "BR-Corte 2016 (English)",
          "BR-Corte 2016 (Inglés)",
        ],
        action: "/livro2016en",
      },
      {
        title: [
          "BR-Corte 2023 (Português)",
          "BR-Corte 2023 (Portuguese)",
          "BR-Corte 2023 (Lengua portuguesa)",
        ],
        action: "/livro2023br",
      },
      {
        title: [
          "BR-Corte 2023 (Inglês)",
          "BR-Corte 2023 (English)",
          "BR-Corte 2023 (Inglés)",
        ],
        action: "/livro2023en",
      },
      // AB#5409
      // {
      //   title: ["Comprar", "Buy", "Compra"],
      //   action:
      //     "https://loja.brcorte.com.br/produto/exigencias-nutricionais-de-zebuinos-puros-e-cruzados-br-corte-3a-edicao/",
      //   nova_aba: true,
      // },
    ],
    planilhas: [
      {
        title: [
          "Exigências nutricionais de bovinos de corte (Português)",
          "Nutrient requirements of cattle (Portuguese)",
          "Requerimientos nutricionales de bovinos de carne (Portugués)",
        ],
        action: "Exigências nutricionais de bovinos de corte.xlsx",
      },
      {
        title: [
          "Exigências nutricionais de bovinos de corte (Inglês)",
          "Nutrient requirements of cattle (English)",
          "Requerimientos nutricionales del ganado bovino (Inglés)",
        ],
        action: "Nutrient requirements of cattle.xlsx",
      },
      {
        title: [
          "Predição do valor energético de dietas para bovinos (Português)",
          "Prediction of the energy value of cattle diets (Portuguese)",
          "Predicción del valor energético de las dietas para bovinos (Portugués)",
        ],
        action: "Predição do valor energético de dietas para  bovinos.xlsx",
      },
      {
        title: [
          "Predição do valor energético de dietas para bovinos (Inglês)",
          "Prediction of the energy value of cattle diets (English)",
          "Predicción del valor energético de las dietas para bovinos (Inglés)",
        ],
        action: "Prediction of the energy value of cattle diets.xlsx",
      },
    ],
  },
  strings: strings,
  optionsNumber: {
    int: [
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 0,
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
      },
    ],
    float: [
      {
        decimal: ",",
        thousands: ".",
        precision: 1,
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 1,
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 1,
      },
    ],
    float2: [
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 2,
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
      },
    ],
    money: [
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$",
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 2,
        prefix: "$",
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "$",
      },
    ],
    moneyInt: [
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
        prefix: "R$",
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 0,
        prefix: "$",
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
        prefix: "$",
      },
    ],
    porcentagemInt: [
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
        suffix: "%",
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 0,
        suffix: "%",
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 0,
        suffix: "%",
      },
    ],
    porcentagemLivre: [
      {
        decimal: ",",
        thousands: ".",
        suffix: "%",
      },
      {
        decimal: ".",
        thousands: ",",
        suffix: "%",
      },
      {
        decimal: ",",
        thousands: ".",
        suffix: "%",
      },
    ],
    porcentagemFloat: [
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: "%",
      },
      {
        decimal: ".",
        thousands: ",",
        precision: 2,
        suffix: "%",
      },
      {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: "%",
      },
    ],
  },
  headersComposicaoRacao: [
    [
      {
        text: "Dado",
        sortable: "false",
      },
      {
        text: "Total",
        sortable: "false",
      },
    ],
    [
      {
        text: "Data",
        sortable: "false",
      },
      {
        text: "Total",
        sortable: "false",
      },
    ],
    [
      {
        text: "Dado",
        sortable: "false",
      },
      {
        text: "Total",
        sortable: "false",
      },
    ],
  ],
  headersExigencias: [
    [
      [
        {
          text: "Exigência",
          sortable: "false",
          value: "exigencia",
        },
        {
          text: "Código",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Unidade",
          sortable: "false",
          value: "unidade",
        },
        {
          text: "Mínimo",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Requerido",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Máximo",
          sortable: "false",
          value: "maximo",
        },
      ],
      [
        {
          text: "CÓDIGO",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Min",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Requerido",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Max",
          sortable: "false",
          value: "maximo",
        },
      ],
    ],
    [
      [
        {
          text: "Nutritional requirements",
          sortable: "false",
          value: "exigencia",
        },
        {
          text: "Code",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Unity",
          sortable: "false",
          value: "unidade",
        },
        {
          text: "Minimum",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Required",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Maximum",
          sortable: "false",
          value: "maximo",
        },
      ],
      [
        {
          text: "CODE",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Min",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Required",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Max",
          sortable: "false",
          value: "maximo",
        },
      ],
    ],
    [
      [
        {
          text: "Requerimientos nutricionales",
          sortable: "false",
          value: "exigencia",
        },
        {
          text: "Cod",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Unidad",
          sortable: "false",
          value: "unidade",
        },
        {
          text: "Min",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Requerido",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Max",
          sortable: "false",
          value: "maximo",
        },
      ],
      [
        {
          text: "COD",
          sortable: "false",
          value: "codigo",
        },
        {
          text: "Min",
          sortable: "false",
          value: "minimo",
        },
        {
          text: "Required",
          sortable: "false",
          value: "ideal",
        },
        {
          text: "Max",
          sortable: "false",
          value: "maximo",
        },
      ],
    ],
  ],
  headersExigenciasRelatorio: [
    [
      [
        {
          text: "Exigência",
          sortable: "false",
        },
        {
          text: "Código",
          sortable: "false",
        },
        {
          text: "Unidade",
          sortable: "false",
        },
        {
          text: "Mínimo",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Máximo",
          sortable: "false",
        },
        {
          text: "Proporção MS",
          sortable: "false",
        },
      ],
      [
        {
          text: "CÓDIGO",
          sortable: "false",
        },
        {
          text: "Min",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
    [
      [
        {
          text: "Nutritional requirements",
          sortable: "false",
        },
        {
          text: "Code",
          sortable: "false",
        },
        {
          text: "Unity",
          sortable: "false",
        },
        {
          text: "Minimum",
          sortable: "false",
        },
        {
          text: "Diet",
          sortable: "false",
        },
        {
          text: "Maximum",
          sortable: "false",
        },
        {
          text: "Proportion",
          sortable: "false",
        },
      ],
      [
        {
          text: "CODE",
          sortable: "false",
        },
        {
          text: "Min",
          sortable: "false",
        },
        {
          text: "Diet",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
    [
      [
        {
          text: "Requerimientos nutricionales",
          sortable: "false",
        },
        {
          text: "Código",
          sortable: "false",
        },
        {
          text: "Unidad",
          sortable: "false",
        },
        {
          text: "Mínimo",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Máximo",
          sortable: "false",
        },
        {
          text: "Proporción",
          sortable: "false",
        },
      ],
      [
        {
          text: "Cód",
          sortable: "false",
        },
        {
          text: "Min",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
  ],
  headersListEmpresas: [
    [
      {
        text: "",
        sortable: false,
        width: "auto",
        align: "auto",
      },
      {
        text: "ID",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Nome",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "CNPJ",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Telefone",
        align: "auto",
        sortable: false,
        width: "auto",
      },
    ],
    [
      {
        text: "",
        sortable: false,
        width: "auto",
        align: "left",
      },
      {
        text: "ID",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Name",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "CNPJ",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Telephone",
        align: "auto",
        sortable: false,
        width: "auto",
      },
    ],
    [
      {
        text: "",
        sortable: false,
        width: "auto",
        align: "left",
      },
      {
        text: "ID",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Nombre",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "CNPJ",
        align: "auto",
        sortable: false,
        width: "auto",
      },
      {
        text: "Teléfono",
        align: "auto",
        sortable: false,
        width: "auto",
      },
    ],
  ],
  headersExigenciasRelatorioPredicao: [
    [
      [
        {
          text: "Exigência",
          sortable: "false",
        },
        {
          text: "Código",
          sortable: "false",
        },
        {
          text: "Unidade",
          sortable: "false",
        },
        {
          text: "Requerido",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Máximo",
          sortable: "false",
        },
        {
          text: "Proporção MS",
          sortable: "false",
        },
      ],
      [
        {
          text: "CÓDIGO",
          sortable: "false",
        },
        {
          text: "Requerido",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
    [
      [
        {
          text: "Nutritional requirements",
          sortable: "false",
        },
        {
          text: "Code",
          sortable: "false",
        },
        {
          text: "Unity",
          sortable: "false",
        },
        {
          text: "Required",
          sortable: "false",
        },
        {
          text: "Diet",
          sortable: "false",
        },
        {
          text: "Maximum",
          sortable: "false",
        },
        {
          text: "Proportion",
          sortable: "false",
        },
      ],
      [
        {
          text: "CODE",
          sortable: "false",
        },
        {
          text: "Req.",
          sortable: "false",
        },
        {
          text: "Diet",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
    [
      [
        {
          text: "Requerimientos nutricionales",
          sortable: "false",
        },
        {
          text: "Código",
          sortable: "false",
        },
        {
          text: "Unidad",
          sortable: "false",
        },
        {
          text: "Mínimo",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Máximo",
          sortable: "false",
        },
        {
          text: "Proporción",
          sortable: "false",
        },
      ],
      [
        {
          text: "Cód",
          sortable: "false",
        },
        {
          text: "Min",
          sortable: "false",
        },
        {
          text: "Dieta",
          sortable: "false",
        },
        {
          text: "Max",
          sortable: "false",
        },
        {
          text: "Prop.",
          sortable: "false",
        },
      ],
    ],
  ],
  headersRelatorioFinanceiro: [
    {
      title: [
        "Indicadores Gerais",
        "General Indicators",
        "Indicadores Generales",
      ],
      id: "IAE",
    },
    {
      title: [
        "Avaliação Total da Operação",
        "Total Operation Evaluation",
        "Evaluación total de la operación",
      ],
      id: "ATC",
    },
  ],
  aditivos: [],
  ingredientes: {
    MS: {
      id: "MS",
      SYS: "MS",
      codigo: "MS",
      codigo_en: "DM",
      codigo_es: "MS",
      exigencia: "Matéria Seca",
      exigencia_en: "Dry matter",
      exigencia_es: "Matéria Seca",
      unidade: "%",
      unidade_en: "%",
      unidade_es: "%",
    },
    MM: {
      id: "MM",
      SYS: "MM",
      codigo: "MM",
      codigo_es: "MM",
      codigo_en: "Ash",
      exigencia: "Matéria Mineral",
      exigencia_en: "Mineral",
      exigencia_es: "Materia Mineral",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    EE: {
      id: "EE",
      SYS: "EE",
      codigo: "EE",
      codigo_en: "EE",
      codigo_es: "EE",
      exigencia: "Extrato Etéreo",
      exigencia_es: "Extracto Etéreo",
      exigencia_en: "Ether Extract",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDN: {
      id: "FDN",
      SYS: "FDN",
      codigo: "FDN",
      codigo_en: "NDF",
      codigo_es: "FDN",
      exigencia: "Fibra em Detergente Neutro",
      exigencia_en: "Neutral Detergent Fiber",
      exigencia_es: "Fibra en Detergente Neutro",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDNfe: {
      id: "FDNfe",
      SYS: "FDNfe",
      codigo: "FDNfe",
      codigo_en: "peNDF",
      codigo_es: "FDNfe",
      exigencia: "Fibra em Detergente Neutro Fisicamente Efetiva",
      exigencia_en: "Physically Effective Neutral Detergent Fiber",
      exigencia_es: "Fibra en detergente neutro físicamente efectivo",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDA: {
      id: "FDA",
      SYS: "FDA",
      codigo: "FDA",
      codigo_en: "ADF",
      codigo_es: "FDA",
      exigencia: "Fibra em Detergente Ácido",
      exigencia_en: "Acid Detergent Fiber",
      exigencia_es: "Fibra en Detergente Ácido",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    CNF: {
      id: "CNF",
      SYS: "CNF",
      codigo: "CNF",
      codigo_en: "NFC",
      codigo_es: "CNF",
      exigencia: "Carboidratos Não Fibrosos",
      exigencia_en: "Non-Fiber carbohydrates",
      exigencia_es: "Carbohidratos no fibrosos",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
    },
    NDT: {
      id: "NDT_BRCORTE2016",
      SYS: "NDT Obs",
      codigo: "NDT",
      codigo_en: "TDN",
      codigo_es: "NDT",
      exigencia: "Nutrientes Digestíveis Totais",
      exigencia_en: "Total digestible nutrients",
      exigencia_es: "Nutrientes digeribles totales",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PB: {
      id: "PB",
      SYS: "PB",
      codigo: "PB",
      codigo_en: "CP",
      codigo_es: "PC",
      exigencia: "Proteína Bruta",
      exigencia_en: "Crude Protein",
      exigencia_es: "Proteína Cruda",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PBA: {
      id: "PBA",
      SYS: "PB A",
      codigo: "PBA",
      codigo_en: "CP A",
      codigo_es: "PCA",
      exigencia: "PB Fração Solúvel A",
      exigencia_en: "Rumen soluble protein fraction A",
      exigencia_es: "PC Soluble Fracción A",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PBB: {
      id: "PBB",
      SYS: "PB B",
      codigo: "PBB",
      codigo_en: "CP B",
      codigo_es: "PC B",
      exigencia: "PB Fração Solúvel B",
      exigencia_es: "PC Fracción Soluble B",
      exigencia_en: "Rumen soluble protein fraction B",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PBKD: {
      id: "PBKD",
      SYS: "PB kd",
      codigo: "PB kd",
      codigo_en: "CP kd",
      codigo_es: "PC kd",
      exigencia: "PB Taxa de Degradação",
      exigencia_en: "Degradation rate of fraction B",
      exigencia_es: "Tasa de degradación de PC",
      unidade: "%",
      unidade_en: "%",
      unidade_es: "%",
    },
    PDR: {
      id: "PDR",
      SYS: "PDR",
      codigo: "PDR",
      codigo_en: "RDP",
      codigo_es: "PDR",
      exigencia: "Proteína Degradável no Rúmen",
      exigencia_en: "Rumen Degradable Protein",
      exigencia_es: "Proteína degradable en el rumen",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PDRPB: {
      id: "PDRPB",
      SYS: "PDR PB",
      codigo: "PDR PB",
      codigo_en: "RDP",
      codigo_es: "PDR PB",
      exigencia: "Proteína Degradável no Rúmen",
      exigencia_en: "Rumen Degradable Protein",
      exigencia_es: "Proteína degradable en el rumen",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PNDR: {
      id: "PNDR",
      SYS: "PNDR",
      codigo: "PNDR",
      codigo_en: "RUP",
      codigo_es: "PNDR",
      exigencia: "Proteína Não Degradável no Rúmen",
      exigencia_en: "Rumen Undegradable Protein",
      exigencia_es: "Proteína no degradable en el rumen",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PNDRPB: {
      id: "PNDRPB",
      SYS: "PNDR PB",
      codigo: "PNDR PB",
      codigo_en: "RUP",
      codigo_es: "PNDR PB",
      exigencia: "Proteína Não Degradável no Rúmen",
      exigencia_en: "Rumen Undegradable Protein",
      exigencia_es: "Proteína no degradable en el rumen",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    NNP: {
      id: "NNP",
      SYS: "NNP",
      codigo: "NNP",
      codigo_en: "NPM",
      codigo_es: "NNP",
      exigencia: "Nitrogênio Não Protéico",
      exigencia_en: "Non-Protein Nitrogen",
      exigencia_es: "Nitrógeno No Proteico",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
    },
    AMIDO: {
      id: "AMIDO",
      SYS: "AMIDO",
      codigo: "AMIDO",
      codigo_en: "STARCH",
      codigo_es: "ALMIDÓN",
      exigencia: "Teor de Amido",
      exigencia_en: "Starch Content",
      exigencia_es: "Contenido de Almidón",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    Ca: {
      id: "CA",
      SYS: "Ca",
      codigo: "Ca",
      codigo_en: "Ca",
      codigo_es: "Ca",
      exigencia: "Cálcio",
      exigencia_en: "Calcium",
      exigencia_es: "Calcio",
      // 'unidade': '%MS',
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    P: {
      id: "P",
      SYS: "P",
      codigo: "P",
      codigo_en: "P",
      codigo_es: "P",
      exigencia: "Fósforo",
      exigencia_en: "Phosphorus",
      exigencia_es: "Fósforo",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Mg: {
      id: "MG",
      SYS: "Mg",
      codigo: "Mg",
      codigo_en: "Mg",
      codigo_es: "Mg",
      exigencia: "Magnésio",
      exigencia_en: "Magnesium",
      exigencia_es: "Magnesio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    K: {
      id: "K",
      SYS: "K",
      codigo: "K",
      codigo_en: "K",
      codigo_es: "K",
      exigencia: "Potássio",
      exigencia_en: "Potassium",
      exigencia_es: "Potasio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Na: {
      id: "NA",
      SYS: "Na",
      codigo: "Na",
      codigo_en: "Na",
      codigo_es: "Na",
      exigencia: "Sódio",
      exigencia_en: "Sodium",
      exigencia_es: "Sodio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    S: {
      id: "S",
      SYS: "S",
      codigo: "S",
      codigo_en: "S",
      codigo_es: "S",
      exigencia: "Enxofre",
      exigencia_en: "Sulfur",
      exigencia_es: "Azufre",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Co: {
      id: "CO",
      SYS: "Co",
      codigo: "Co",
      codigo_en: "Co",
      codigo_es: "Co",
      exigencia: "Cobalto",
      exigencia_en: "Cobalt",
      exigencia_es: "Cobalto",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Cu: {
      id: "CU",
      SYS: "Cu",
      codigo: "Cu",
      codigo_en: "Cu",
      codigo_es: "Cu",
      exigencia: "Cobre",
      exigencia_en: "Copper",
      exigencia_es: "Cobre",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    I: {
      id: "I",
      SYS: "I",
      codigo: "I",
      codigo_en: "I",
      codigo_es: "I",
      exigencia: "Iodo",
      exigencia_en: "Iodine",
      exigencia_es: "Yodo",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Mn: {
      id: "MN",
      SYS: "Mn",
      codigo: "Mn",
      codigo_en: "Mn",
      codigo_es: "Mn",
      exigencia: "Manganês",
      exigencia_en: "Manganese",
      exigencia_es: "Manganeso",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Se: {
      id: "SE",
      SYS: "Se",
      codigo: "Se",
      codigo_en: "Se",
      codigo_es: "Se",
      exigencia: "Selênio",
      exigencia_en: "Selenium",
      exigencia_es: "Selenio",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Zn: {
      id: "ZN",
      SYS: "Zn",
      codigo: "Zn",
      codigo_en: "Zn",
      codigo_es: "Zn",
      exigencia: "Zinco",
      exigencia_en: "Zinc",
      exigencia_es: "Zinc",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
  },
  ingredientesCompletos: {
    MS: {
      id: "MS",
      SYS: "MS",
      codigo: "MS",
      codigo_en: "DM",
      codigo_es: "MS",
      exigencia: "Matéria Seca",
      exigencia_en: "Dry matter",
      exigencia_es: "Materia Seca",
      unidade: "%",
      unidade_en: "%",
      unidade_es: "%",
    },
    MM: {
      id: "MM",
      SYS: "MM",
      codigo: "MM",
      codigo_es: "MM",
      codigo_en: "Ash",
      exigencia: "Matéria Mineral",
      exigencia_en: "Mineral",
      exigencia_es: "Materia Mineral",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    EE: {
      id: "EE",
      SYS: "EE",
      codigo: "EE",
      codigo_en: "EE",
      codigo_es: "EE",
      exigencia: "Extrato Etéreo",
      exigencia_en: "Ether Extract",
      exigencia_es: "Extracto Etéreo",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    lignina: {
      id: "lignina",
      SYS: "lignina",
      codigo: "lignina",
      codigo_en: "lignin",
      codigo_es: "lignina",
      exigencia: "Lignina",
      exigencia_en: "Lignin",
      exigencia_es: "Lignina",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDN: {
      id: "FDN",
      SYS: "FDN",
      codigo: "FDN",
      codigo_en: "NDF",
      codigo_es: "FDN",
      exigencia: "Fibra em Detergente Neutro",
      exigencia_en: "Neutral Detergent Fiber",
      exigencia_es: "Fibra en Detergente Neutro",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDNi: {
      id: "FDNi",
      SYS: "FDNi",
      codigo: "FDNi",
      codigo_en: "NDFi",
      codigo_es: "FDNi",
      exigencia: "Fibra em Detergente Neutro Indigestível",
      exigencia_en: "Indigestible Neutral Detergent Fiber",
      exigencia_es: "Fibra en Detergente Neutro No Digerible",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDNfe: {
      id: "FDNfe",
      SYS: "FDNfe",
      codigo: "FDNfe",
      codigo_en: "peNDF",
      codigo_es: "FDNfe",
      exigencia: "Fibra em Detergente Neutro Fisicamente Efetiva",
      exigencia_en: "Physically Effective Neutral Detergent Fiber",
      exigencia_es: "Fibra en detergente neutro físicamente efectivo",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    FDA: {
      id: "FDA",
      SYS: "FDA",
      codigo: "FDA",
      codigo_en: "ADF",
      codigo_es: "FDA",
      exigencia: "Fibra em Detergente Ácido",
      exigencia_en: "Acid Detergent Fiber",
      exigencia_es: "Fibra en detergente ácido",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    CNF: {
      id: "CNF",
      SYS: "CNF",
      codigo: "CNF",
      codigo_en: "NFC",
      codigo_es: "CNF",
      exigencia: "Carboidratos Não Fibrosos",
      exigencia_en: "Non-Fiber carbohydrates",
      exigencia_es: "Carbohidratos no fibrosos",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    NIDA: {
      id: "NIDA",
      SYS: "NIDA",
      codigo: "NIDA",
      codigo_en: "NIDA",
      codigo_es: "NIDA",
      exigencia: "Nitrogênio Insolúvel em Detergente Ácido",
      exigencia_en: "Acid Detergent Insoluble Nitrogen",
      exigencia_es: "Nitrógeno insoluble en detergente ácido",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    NIDN: {
      id: "NIDN",
      SYS: "NIDN",
      codigo: "NIDN",
      codigo_en: "NIND",
      codigo_es: "NIDN",
      exigencia: "Nitrogênio Insolúvel em Detergente Neutro",
      exigencia_en: "Nitrogen Insoluble in Neutral Detergent",
      exigencia_es: "Nitrógeno insoluble en detergente neutro",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    NDT: {
      id: "NDT_BRCORTE2016",
      SYS: "NDT",
      codigo: "NDT",
      codigo_en: "TDN",
      codigo_es: "NDT",
      exigencia: "Nutrientes Digestíveis Totais (Observado)",
      exigencia_en: "Total digestible nutrients",
      exigencia_es: "Nutrientes digeribles totales (observados)",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PB: {
      id: "PB",
      SYS: "PB",
      codigo: "PB",
      codigo_en: "CP",
      codigo_es: "PC",
      exigencia: "Proteína Bruta",
      exigencia_en: "Crude Protein",
      exigencia_es: "Proteína Cruda",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PBA: {
      id: "PB A",
      SYS: "PB A",
      codigo: "PB A",
      codigo_en: "CP A",
      codigo_es: "PC A",
      exigencia: "PB Fração Solúvel A",
      exigencia_en: "Rumen soluble protein fraction A",
      exigencia_es: "PC Soluble Fracción A",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PBB: {
      id: "PB B",
      SYS: "PB B",
      codigo: "PB B",
      codigo_en: "CP B",
      codigo_es: "PC B",
      exigencia: "PB Fração Solúvel B",
      exigencia_en: "Rumen soluble protein fraction B",
      exigencia_es: "PC Soluble Fracción B",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PBKD: {
      id: "PBKD",
      SYS: "PB kd",
      codigo: "PB kd",
      codigo_en: "CP kd",
      codigo_es: "PC kd",
      exigencia: "PB Taxa de Degradação",
      exigencia_en: "Degradation rate of fraction B",
      exigencia_es: "Tasa de degradación de PC",
      unidade: "%",
      unidade_en: "%",
      unidade_es: "%",
    },
    PDR: {
      id: "PDR",
      SYS: "PDR",
      codigo: "PDR",
      codigo_en: "RDP",
      codigo_es: "PDR",
      exigencia: "Proteína Degradável no Rúmen",
      exigencia_en: "Rumen Degradable Protein",
      exigencia_es: "Proteína degradable en el rumen",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PDRPB: {
      id: "PDR PB",
      SYS: "PDR PB",
      codigo: "PDR PB",
      codigo_en: "RDP",
      codigo_es: "PDR PC",
      exigencia: "Proteína Degradável no Rúmen",
      exigencia_en: "Rumen Degradable Protein",
      exigencia_es: "Proteína degradable en el rumen",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PNDR: {
      id: "PNDR",
      SYS: "PNDR",
      codigo: "PNDR",
      codigo_en: "RUP",
      codigo_es: "PNDR",
      exigencia: "Proteína Não Degradável no Rúmen",
      exigencia_en: "Rumen Undegradable Protein",
      exigencia_es: "Proteína no degradable en el rumen",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PNDRPB: {
      id: "PNDR PB",
      SYS: "PNDR PB",
      codigo: "PNDR PB",
      codigo_en: "RUP",
      codigo_es: "PNDR PC",
      exigencia: "Proteína Não Degradável no Rúmen",
      exigencia_en: "Rumen Undegradable Protein",
      exigencia_es: "Proteína no degradable en el rumen",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PIDA: {
      id: "PIDA",
      SYS: "PIDA",
      codigo: "PIDA",
      codigo_en: "ADIP",
      codigo_es: "PIDA",
      exigencia: "Proteína Insolúvel em Detergente Ácido",
      exigencia_en: "Acid Detergent Insoluble Protein",
      exigencia_es: "Proteína insoluble en detergente ácido",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PIDN: {
      id: "PIDN",
      SYS: "PIDN",
      codigo: "PIDN",
      codigo_en: "NDIP",
      codigo_es: "PIDN",
      exigencia: "Proteína Insolúvel em Detergente Neutro",
      exigencia_en: "Neutral Detergent Insoluble Protein",
      exigencia_es: "Proteína insoluble en detergente neutro",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    PIDAPB: {
      id: "PIDAPB",
      SYS: "PIDA PB",
      codigo: "PIDAPB",
      codigo_en: "CP ADIP",
      codigo_es: "PIDA PC",
      exigencia: "Proteína Insolúvel em Detergente Ácido",
      exigencia_en: "Acid Detergent Insoluble Protein",
      exigencia_es: "Proteína insoluble en detergente ácido",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    PIDNPB: {
      id: "PIDNPB",
      SYS: "PIDN PB",
      codigo: "PIDNPB",
      codigo_en: "CP NDIP",
      codigo_es: "PIDN PC",
      exigencia: "Proteína Insolúvel em Detergente Neutro",
      exigencia_en: "Neutral Detergent Insoluble Protein",
      exigencia_es: "Proteína insoluble en detergente neutro",
      unidade: "%PB",
      unidade_en: "%CP",
      unidade_es: "%PC",
    },
    NNP: {
      id: "NNP",
      SYS: "NNP",
      codigo: "NNP",
      codigo_en: "NPM",
      codigo_es: "NNP",
      exigencia: "Nitrogênio Não Protéico",
      exigencia_en: "Non-Protein Nitrogen",
      exigencia_es: "Nitrógeno No Proteico",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
    },
    AMIDO: {
      id: "AMIDO",
      SYS: "AMIDO",
      codigo: "AMIDO",
      codigo_en: "STARCH",
      codigo_es: "ALMIDÓN",
      exigencia: "Teor de Amido",
      exigencia_en: "Starch Content",
      exigencia_es: "Contenido de almidón",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      alt: "g_kg_aviso",
    },
    Ca: {
      id: "CA",
      SYS: "Ca",
      codigo: "Ca",
      codigo_en: "Ca",
      codigo_es: "Ca",
      exigencia: "Cálcio",
      exigencia_en: "Calcium",
      exigencia_es: "Calcio",
      // 'unidade': '%MS',
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    P: {
      id: "P",
      SYS: "P",
      codigo: "P",
      codigo_en: "P",
      codigo_es: "P",
      exigencia: "Fósforo",
      exigencia_en: "Phosphorus",
      exigencia_es: "Fósforo",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Mg: {
      id: "MG",
      SYS: "Mg",
      codigo: "Mg",
      codigo_en: "Mg",
      codigo_es: "Mg",
      exigencia: "Magnésio",
      exigencia_en: "Magnesium",
      exigencia_es: "Magnesio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    K: {
      id: "K",
      SYS: "K",
      codigo: "K",
      codigo_en: "K",
      codigo_es: "K",
      exigencia: "Potássio",
      exigencia_en: "Potassium",
      exigencia_es: "Potasio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Na: {
      id: "NA",
      SYS: "Na",
      codigo: "Na",
      codigo_en: "Na",
      codigo_es: "Na",
      exigencia: "Sódio",
      exigencia_en: "Sodium",
      exigencia_es: "Sodio",
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    S: {
      id: "S",
      SYS: "S",
      codigo: "S",
      codigo_en: "S",
      codigo_es: "S",
      exigencia: "Enxofre",
      exigencia_en: "Sulfur",
      exigencia_es: "Azufre",
      // unidade que vem do cqbal
      unidade: "%MS",
      unidade_en: "%DM",
      unidade_es: "%MS",
      // unidade requerida pelo sistema;
      unidade_alt: "g/kg",
      unidade_alt_en: "g/kg",
      unidade_alt_es: "g/kg",
      // fator de conversão do valor original para o alternativo;
      fator_conv_alt: 0.1,
      alt: "g_kg_to_ms_aviso",
    },
    Co: {
      id: "CO",
      SYS: "Co",
      codigo: "Co",
      codigo_en: "Co",
      codigo_es: "Co",
      exigencia: "Cobalto",
      exigencia_en: "Cobalt",
      exigencia_es: "Cobalto",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Cu: {
      id: "CU",
      SYS: "Cu",
      codigo: "Cu",
      codigo_en: "Cu",
      codigo_es: "Cu",
      exigencia: "Cobre",
      exigencia_en: "Copper",
      exigencia_es: "Cobre",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    I: {
      id: "I",
      SYS: "I",
      codigo: "I",
      codigo_en: "I",
      codigo_es: "I",
      exigencia: "Iodo",
      exigencia_en: "Iodine",
      exigencia_es: "Yodo",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Mn: {
      id: "MN",
      SYS: "Mn",
      codigo: "Mn",
      codigo_en: "Mn",
      codigo_es: "Mn",
      exigencia: "Manganês",
      exigencia_en: "Manganese",
      exigencia_es: "Manganeso",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Se: {
      id: "SE",
      SYS: "Se",
      codigo: "Se",
      codigo_en: "Se",
      codigo_es: "Se",
      exigencia: "Selênio",
      exigencia_en: "Selenium",
      exigencia_es: "Selenio",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
    Zn: {
      id: "ZN",
      SYS: "Zn",
      codigo: "Zn",
      codigo_en: "Zn",
      codigo_es: "Zn",
      exigencia: "Zinco",
      exigencia_en: "Zinc",
      exigencia_es: "Zinc",
      unidade: "mg/kg",
      unidade_en: "mg/kg",
      unidade_es: "mg/kg",
    },
  },
  leiteDeVaca: {
    name: "LEITE DE VACA",
    name_en: "COW MILK",
    name_es: "Leche de Vaca",
    id: ID_LEITE_VACA,
    tipo: 0,
    alterado: false,
    restrito: true,
    custo: null,
    minimo: null,
    maximo: null,
    nutrientes: {
      EEvD_BRCORTE2016: 0,
      CNFvD_BRCORTE2016: 0,
      FDNpd_BRCORTE2016: 0,
      FDND_BRCORTE2016: 0,
      PBvD_BRCORTE2016: 0,
      NDT_BRCORTE2016: (0.18 / 0.1392) * 100,
      ED_BRCORTE2016: 0,
      EM_BRCORTE2016: 1.14 / 0.1392,
      MM: 0,
      CNF: 0.0459,
      EE: 5.61,
      FDA: 0,
      lignina: 0,
      PB: 36.9 / 0.1392 / 10,
      FDN: 0,
      PDR: 0,
      PNDR: 35.9 / 0.1392 / 10,
      CA: 1.11 / 0.1392 / 10,
      P: 0.76 / 0.1392 / 10,
      S: 0.025 / 0.1392,
      MG: 0.07 / 0.1392 / 10,
      K: 0.7 / 0.1392 / 10,
      NA: 0.2 / 0.1392 / 10,
      CO: 2.29 / 0.1392,
      CU: 1.98 / 0.1392,
      I: 0.1 / 0.1392,
      MN: 1.4 / 0.1392,
      SE: 0.05 / 0.1392,
      ZN: 35.4 / 0.1392,
      PBA: 0,
      PBB: 0,
      PBKD: 0,
      PDRPB: 0,
      PNDRPB: 0.95 / 0.1392,
      PM: 30.86,
      MS: 13.92,
      EL: (0.82 / 0.1392) / 100,
      FDNfe: 0,
      AMIDO: 0,
    },
    nutrientes_originais: {
      EEvD_BRCORTE2016: 0,
      CNFvD_BRCORTE2016: 0,
      FDNpd_BRCORTE2016: 0,
      FDND_BRCORTE2016: 0,
      PBvD_BRCORTE2016: 0,
      NDT_BRCORTE2016: (0.18 / 0.1392) * 100,
      ED_BRCORTE2016: 0,
      EM_BRCORTE2016: 1.14 / 0.1392,
      MM: 0,
      CNF: 0.0459,
      EE: 5.61,
      FDA: 0,
      lignina: 0,
      PB: 36.9 / 0.1392 / 10,
      FDN: 0,
      PDR: 0,
      PNDR: 35.9 / 0.1392 / 10,
      CA: 1.11 / 0.1392 / 10,
      P: 0.76 / 0.1392 / 10,
      S: 0.025 / 0.1392,
      MG: 0.07 / 0.1392 / 10,
      K: 0.7 / 0.1392 / 10,
      NA: 0.2 / 0.1392 / 10,
      CO: 2.29 / 0.1392,
      CU: 1.98 / 0.1392,
      I: 0.1 / 0.1392,
      MN: 1.4 / 0.1392,
      SE: 0.05 / 0.1392,
      ZN: 35.4 / 0.1392,
      PBA: 0,
      PBB: 0,
      PBKD: 0,
      PDRPB: 0,
      PNDRPB: 0.95 / 0.1392,
      PM: 30.86,
      MS: 13.92,
      EL: (0.82 / 0.1392) / 100,
      FDNfe: 0,
      AMIDO: 0,
    },
  },
};
